var React = require('react');

function PlusInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.334 19.404a1.06 1.06 0 0 1-.999-1.048V1.689c0-.552.448-.978 1-.952.55.027.998.496.998 1.048v16.667a.944.944 0 0 1-.999.952Z","fill":"#fff","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M.618 10.453a.944.944 0 0 1 .952-1h16.667a1.06 1.06 0 0 1 1.048 1 .944.944 0 0 1-.952.998H1.666a1.06 1.06 0 0 1-1.048-.998Z","fill":"#fff","key":1})]);
}

PlusInline.defaultProps = {"width":"20","height":"20","fill":"none"};

module.exports = PlusInline;

PlusInline.default = PlusInline;
